var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AngularFireModule, AuthProviders, AuthMethods } from 'angularfire2';
import { MyApp } from './app.component';
import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { TabSideMenu } from '../pages/tabs/tab-sidemenu';
import { LandingPage } from '../pages/landing/landing';
import { ProfilePage } from '../pages/profile/profile';
import { WelcomePage } from '../pages/welcome/welcome';
import { ChatPage } from '../pages/chat/chat';
import { ViewPostPage } from '../pages/posts/view';
import { PostsPage } from '../pages/posts/posts';
import { JoinedTradesPage } from '../pages/joined/joined';
import { HelpPage } from '../pages/help/help';
import { PostList } from '../directives/post-list/post-list';
import { NeighborhoodTag } from '../directives/neighborhood-tag/neighborhood-tag';
import { TradeCard } from '../directives/trade-card/trade-card';
import { HayDayItemDisplay } from '../directives/haydayitem/haydayitem';
import { ChatMenuPopover } from '../pages/chat/chatmenu';
import { PostSearchList } from '../directives/post-search-list/post-search-list';
import { ErrorSrcDirective } from '../directives/error-src/error-src';
import { CreatePostDialog } from '../dialogs/create-post/create-post';
import { ItemSelectDialog } from '../dialogs/item-select/item-select';
import { FaqDialog } from '../dialogs/faq/faq';
import { FinishTradeDialog } from '../dialogs/finish-trade/finish-trade';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { ChatService } from '../services/chat.service';
import { PostService } from '../services/post.service';
import { RecentItemsService } from '../services/recentitems.service';
import { ItemsOfTypePipe, SearchPipe } from '../pipes/haydayitem.pipes';
import { TimeAgoPipe } from '../pipes/moment.pipes';
import { OtherUsersPostsPipe, PostMapPipe } from '../pipes/post.pipes';
//Must export the config
export var firebaseConfig = {
    apiKey: 'AIzaSyBI2bfm-c7o1734Y-jGU3-p0tt2ZGrU33g',
    authDomain: 'hdtradingpost-4f9ee.firebaseapp.com',
    databaseURL: 'https://hdtradingpost-4f9ee.firebaseio.com',
    storageBucket: 'hdtradingpost-4f9ee.appspot.com',
    messagingSenderId: '140175978019'
};
export var myFirebaseAuthConfig = {
    provider: AuthProviders.Facebook,
    method: AuthMethods.Popup
};
export var AppModule = (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        NgModule({
            declarations: [
                MyApp,
                AboutPage,
                ContactPage,
                HomePage,
                TabsPage,
                LandingPage,
                ProfilePage,
                WelcomePage,
                TabSideMenu,
                ItemsOfTypePipe,
                SearchPipe,
                TimeAgoPipe,
                PostMapPipe,
                ChatPage,
                ViewPostPage,
                PostList,
                NeighborhoodTag,
                TradeCard,
                HayDayItemDisplay,
                CreatePostDialog,
                ItemSelectDialog,
                ChatMenuPopover,
                PostsPage,
                JoinedTradesPage,
                PostSearchList,
                OtherUsersPostsPipe,
                HelpPage,
                FaqDialog,
                FinishTradeDialog,
                ErrorSrcDirective
            ],
            imports: [
                BrowserModule,
                IonicModule.forRoot(MyApp, {
                    activator: 'ripple',
                    iconMode: 'md',
                    tabsPlacement: 'bottom',
                    tabsLayout: 'title-hide',
                    mode: 'md'
                }),
                AngularFireModule.initializeApp(firebaseConfig, myFirebaseAuthConfig)
            ],
            bootstrap: [IonicApp],
            entryComponents: [
                MyApp,
                AboutPage,
                ContactPage,
                HomePage,
                TabsPage,
                LandingPage,
                ProfilePage,
                WelcomePage,
                ChatPage,
                ViewPostPage,
                CreatePostDialog,
                ItemSelectDialog,
                ChatMenuPopover,
                PostsPage,
                JoinedTradesPage,
                HelpPage,
                FaqDialog,
                FinishTradeDialog
            ],
            providers: [
                Storage,
                AuthService,
                UserService,
                ChatService,
                PostService,
                RecentItemsService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AppModule);
    return AppModule;
}());
